export const aboutMeData = [
  {
    id: 1,
    bio: (
      <h1>
        <span style={{ fontSize: '45px' }}>H</span><span style={{ fontSize: '25px' }}>ey there</span>,
      </h1>
    ),
  },
  {
    id: 2,
    bio: (
      <p style={{ textAlign: 'justify' }}>
       I'm Umar, a Software Engineer and a Passionate Teacher with a touch of humor. 😊
      </p>
    ),
  },
  {
    id: 3,
    bio: (
      <p style={{ textAlign: 'justify' }}>
        My journey with computers began in 4th grade when I first saw one at a friend's house. It felt like magic seeing it instantly display anything I asked for, sparking my curiosity about how it worked. My teacher’s advice to be good at math initially seemed like a bluff to push me to study harder. Little did I know, it was true! 📚
      </p>
    ),
  },
  {
    id: 4,
    bio: (
      <p style={{ textAlign: 'justify' }}>
        Now, as the first-generation software engineer in my family, I’ve built multiple software applications and pursued a bachelor's in CS with a full tuition ride. Currently, I support my master’s education by teaching, emphasizing the importance of math in programming, something my younger self struggled to understand. 👨‍🏫
      </p>
    ),
  },
  {
    id: 5,
    bio: (
      <p style={{ textAlign: 'justify' }}>
        Some recent things 😎 I've done are: Small-scale distributed file storage system in Java, An image classification model leveraging swarm intelligence, A secure multithreaded chat application. I also love solving problems on LeetCode and share my approaches on LinkedIn—check out my posts!
      </p>
    ),
  },
  {
    id: 6,
    bio: (
      <p style={{ textAlign: 'justify' }}>
        When I'm not coding, I enjoy cooking Italian food with South Indian flavors and lifting weights to balance out my culinary indulgences. 🍝🏋️
      </p>
    ),
  },  {
    id: 7,
    bio: (
      <p style={{ textAlign: 'justify' }}>
        Let’s connect and explore how we can make a difference together! 🌟
      </p>
    ),
  }
];
